<script>
let items = [
  { href: "/shop/IboxServlet?p=IXS479&amp;NODE=76", name: "Elektrisk låsning" },
  { href: "/shop/IboxServlet?p=IXS479&amp;NODE=89", name: "Elslutbleck" },
];
</script>

<div id="contenttop" class="row">
  <div class="col-xs-12">
    <ul class="breadcrumb">
      {#each items as { href, name }}
        <li><a href="{href}">{name}</a></li>
      {/each}
    </ul>
  </div>
</div>
